export default class SelectableEntity<T> {
    public entity: T;
    public isSelected = false;

    public constructor(entity: T) {
        this.entity = entity;
    }
}